import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Image from "next/image";
import { AccordionFigure } from "./AccordionItem.styles";
export var Figure = function(param) {
    var image = param.content.image, rules = param.rules;
    if (!image) {
        return null;
    }
    return /*#__PURE__*/ _jsx(AccordionFigure, {
        rules: rules,
        children: /*#__PURE__*/ _jsx(Image, _object_spread({
            layout: "responsive"
        }, image))
    });
};
